import React from "react";
import "./Questions.css";

function Header() {
  return (
    <header>
      <h1>Questions You May Have</h1>
    </header>
  );
}

export default Header;
